import { apiJson } from '../api';
import type { AuthResponse, User } from '../types';

export async function login(usernameOrEmail: string, password: string): Promise<AuthResponse> {
  return apiJson<AuthResponse>('/api/auth/login', {
    method: 'POST',
    json: { usernameOrEmail, password },
    public: true,
  });
}

export async function signup(username: string, email: string, password: string): Promise<AuthResponse> {
  return apiJson<AuthResponse>('/api/auth/signup', {
    method: 'POST',
    json: { username, email, password },
    public: true,
  });
}

export async function requestPasswordReset(email: string): Promise<{ message: string }> {
  return apiJson<{ message: string }>('/api/auth/request-reset', {
    method: 'POST',
    json: { email },
    public: true,
  });
}

export async function resetPassword(token: string, newPassword: string): Promise<void> {
  await apiJson('/api/auth/reset-password', {
    method: 'POST',
    json: { token, new_password: newPassword },
    public: true,
  });
}

export async function fetchCurrentUser(): Promise<User> {
  const data = await apiJson<{ user: User }>('/api/me');
  return data.user;
}
